// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { setBulkReminderSummaryEmail } from 'redux/modules/projectTracker/actions'
import { fetchWrapper } from 'helpers/api'

const getBulkReminderSummaryEmail = () => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      try {
        const data = await fetchWrapper('/bulkReminderEmailSummary')
        dispatch(setBulkReminderSummaryEmail(data))
        return data
      } catch (err) {
        throw err
      }
    })
  )
)

export default getBulkReminderSummaryEmail
